module.exports = __webpack_public_path__ + "fonts/IQOS-Light.743c338.woff2";